import { render, staticRenderFns } from "./SBJData.vue?vue&type=template&id=72abde10&scoped=true&"
import script from "./SBJData.vue?vue&type=script&lang=js&"
export * from "./SBJData.vue?vue&type=script&lang=js&"
import style0 from "./SBJData.vue?vue&type=style&index=0&id=72abde10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72abde10",
  null
  
)

export default component.exports